import { render, staticRenderFns } from "./benefit.vue?vue&type=template&id=5e819ff0&scoped=true"
import script from "./benefit.vue?vue&type=script&lang=js"
export * from "./benefit.vue?vue&type=script&lang=js"
import style0 from "./benefit.vue?vue&type=style&index=0&id=5e819ff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e819ff0",
  null
  
)

export default component.exports